/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import HeadTittle from "../../../../../../../components/HeadTittle";
import {permissionObj} from "../../../../../../../Helpers/permission";
import React from "react";
import ButtonAction from "../../../../../../../components/buttons/ButtonAction";
import CustomTable from "../../../../../../../components/table/CustomTable";
import ChangeRequestTableApp from "../Functionality/ChangeRequestTableApp";
import CustomCard from "../../../../../../../components/CustomCard";
import {getDateFormat} from "../../../../../../../Apis/functions";
import ChangeRequestGuard from "../../../../../../../components/UseNavigationGuard/ChangeRequestGuard";
import routes from "../../../../../../../Routes/routes";
import {ClearRowsAdjusted} from "../../../../../../../reduxToolkit/AttendanceAdjustment/AttendanceAdjustmentPersistSlice";

const ChangeRequestTable = () => {
    const {
        t,
        DEV,
        permission,
        navigate,
        dispatch,
        tableId,
        thead,
        tbody,
        pagination,
        getAttendancePeriodReview,
        handleOnBack,
        badge,
        item,
        handleReviewUpdates,
        disableReviewUpdatesBtn,
        isAttendanceSupervisor
    } = ChangeRequestTableApp();

    if (!DEV &&
        !permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_READ) &&
        !permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_REQUEST_READ) &&
        !isAttendanceSupervisor //Used for attendance department supervisor, for can manage attendees, slice loaded in login action
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'modify_request'} onBack={handleOnBack}>
                { (DEV || isAttendanceSupervisor || permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_MANAGE_ATTENDANCES)) &&
                    <ButtonAction
                        id='btn_crt_review_updates'
                        name='review_updates'
                        className='btn-icon-add'
                        splitName={false}
                        onClick={() => {
                           handleReviewUpdates();
                        }}
                        disabled={disableReviewUpdatesBtn}
                    />
                }

            </HeadTittle>

            { badge &&
                <>
                    <div className={"mb-4"}>
                        <CustomCard
                            classes={`border-radius-8px`}
                            classCard={`border-radius-8px ${badge?.classCard}`}
                            children={
                                <div className={`d-flex flex-column justify-content-start gap-3`}>
                                    <div className={"gap-2"}>
                                        <p className={`ibl-font-w-600 fs-14px ${badge?.fontColor}`}>
                                            {t(badge?.title)}
                                        </p>
                                        {item?.reason && (
                                            <p className={"fs-12px ibl-font-w-600 font-color-shades-800"}>
                                                {item?.reason}
                                            </p>
                                        )}
                                    </div>
                                    <p className={"fs-12px font-color-shades-600"}>
                                        {t(badge?.byTrans)} {item?.approverUser} ·{" "}
                                        {item?.decisionDate !== null ? getDateFormat(item?.decisionDate) : ""}
                                    </p>
                                </div>
                            }
                        />
                    </div>

                    <div>
                        <CustomTable
                            tableId={tableId}
                            checkbox={false}
                            thead={thead}
                            tbody={tbody}
                            columnActions={false}
                            textNotInformation={getAttendancePeriodReview ? 'no_attendance_records_to_review_available' : 'there_not_period_active'}
                        />

                        {pagination()}
                    </div>
                </>
            }

            <ChangeRequestGuard
                hasChanges={!disableReviewUpdatesBtn}
                redirectUrl={routes.attendance.main}
                allowedPaths={[
                    routes.submission.changeRequest,
                    routes.submission.confirmChangeRequest
                ]}
                onConfirm={() => dispatch(ClearRowsAdjusted())}
            />
        </>
    );
};

export default ChangeRequestTable;
